export default __webpack_public_path__ + "static/media/a037-student-t3-s3-1.ce2862f2.svg";